import { render, staticRenderFns } from "./reduction-zero-application.vue?vue&type=template&id=b82794ae"
import script from "./reduction-zero-application.vue?vue&type=script&lang=ts"
export * from "./reduction-zero-application.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports